import { render, staticRenderFns } from "./PhotosImportFromDeviceView.vue?vue&type=template&id=2b4350fa&"
import script from "./PhotosImportFromDeviceView.vue?vue&type=script&lang=js&"
export * from "./PhotosImportFromDeviceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports